import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { each } from '@phosphor/algorithm';
import { ObservableList } from './observablelist';
/**
 * A concrete implementation of an observable undoable list.
 */
export var ObservableUndoableList = /*#__PURE__*/function (_ObservableList) {
  _inherits(ObservableUndoableList, _ObservableList);
  var _super = _createSuper(ObservableUndoableList);
  /**
   * Construct a new undoable observable list.
   */
  function ObservableUndoableList(serializer) {
    var _this;
    _classCallCheck(this, ObservableUndoableList);
    _this = _super.call(this);
    _this._inCompound = false;
    _this._isUndoable = true;
    _this._madeCompoundChange = false;
    _this._index = -1;
    _this._stack = [];
    _this._serializer = serializer;
    _this.changed.connect(_this._onListChanged, _assertThisInitialized(_this));
    return _this;
  }
  /**
   * Whether the object can redo changes.
   */
  _createClass(ObservableUndoableList, [{
    key: "canRedo",
    get: function get() {
      return this._index < this._stack.length - 1;
    }
    /**
     * Whether the object can undo changes.
     */
  }, {
    key: "canUndo",
    get: function get() {
      return this._index >= 0;
    }
    /**
     * Begin a compound operation.
     *
     * @param isUndoAble - Whether the operation is undoable.
     *   The default is `true`.
     */
  }, {
    key: "beginCompoundOperation",
    value: function beginCompoundOperation(isUndoAble) {
      this._inCompound = true;
      this._isUndoable = isUndoAble !== false;
      this._madeCompoundChange = false;
    }
    /**
     * End a compound operation.
     */
  }, {
    key: "endCompoundOperation",
    value: function endCompoundOperation() {
      this._inCompound = false;
      this._isUndoable = true;
      if (this._madeCompoundChange) {
        this._index++;
      }
    }
    /**
     * Undo an operation.
     */
  }, {
    key: "undo",
    value: function undo() {
      if (!this.canUndo) {
        return;
      }
      var changes = this._stack[this._index];
      this._isUndoable = false;
      var _iterator = _createForOfIteratorHelper(changes.reverse()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var change = _step.value;
          this._undoChange(change);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this._isUndoable = true;
      this._index--;
    }
    /**
     * Redo an operation.
     */
  }, {
    key: "redo",
    value: function redo() {
      if (!this.canRedo) {
        return;
      }
      this._index++;
      var changes = this._stack[this._index];
      this._isUndoable = false;
      var _iterator2 = _createForOfIteratorHelper(changes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var change = _step2.value;
          this._redoChange(change);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this._isUndoable = true;
    }
    /**
     * Clear the change stack.
     */
  }, {
    key: "clearUndo",
    value: function clearUndo() {
      this._index = -1;
      this._stack = [];
    }
    /**
     * Handle a change in the list.
     */
  }, {
    key: "_onListChanged",
    value: function _onListChanged(list, change) {
      if (this.isDisposed || !this._isUndoable) {
        return;
      }
      // Clear everything after this position if necessary.
      if (!this._inCompound || !this._madeCompoundChange) {
        this._stack = this._stack.slice(0, this._index + 1);
      }
      // Copy the change.
      var evt = this._copyChange(change);
      // Put the change in the stack.
      if (this._stack[this._index + 1]) {
        this._stack[this._index + 1].push(evt);
      } else {
        this._stack.push([evt]);
      }
      // If not in a compound operation, increase index.
      if (!this._inCompound) {
        this._index++;
      } else {
        this._madeCompoundChange = true;
      }
    }
    /**
     * Undo a change event.
     */
  }, {
    key: "_undoChange",
    value: function _undoChange(change) {
      var _this2 = this;
      var index = 0;
      var serializer = this._serializer;
      switch (change.type) {
        case 'add':
          each(change.newValues, function () {
            _this2.remove(change.newIndex);
          });
          break;
        case 'set':
          index = change.oldIndex;
          each(change.oldValues, function (value) {
            _this2.set(index++, serializer.fromJSON(value));
          });
          break;
        case 'remove':
          index = change.oldIndex;
          each(change.oldValues, function (value) {
            _this2.insert(index++, serializer.fromJSON(value));
          });
          break;
        case 'move':
          this.move(change.newIndex, change.oldIndex);
          break;
        default:
          return;
      }
    }
    /**
     * Redo a change event.
     */
  }, {
    key: "_redoChange",
    value: function _redoChange(change) {
      var _this3 = this;
      var index = 0;
      var serializer = this._serializer;
      switch (change.type) {
        case 'add':
          index = change.newIndex;
          each(change.newValues, function (value) {
            _this3.insert(index++, serializer.fromJSON(value));
          });
          break;
        case 'set':
          index = change.newIndex;
          each(change.newValues, function (value) {
            _this3.set(change.newIndex++, serializer.fromJSON(value));
          });
          break;
        case 'remove':
          each(change.oldValues, function () {
            _this3.remove(change.oldIndex);
          });
          break;
        case 'move':
          this.move(change.oldIndex, change.newIndex);
          break;
        default:
          return;
      }
    }
    /**
     * Copy a change as JSON.
     */
  }, {
    key: "_copyChange",
    value: function _copyChange(change) {
      var _this4 = this;
      var oldValues = [];
      each(change.oldValues, function (value) {
        oldValues.push(_this4._serializer.toJSON(value));
      });
      var newValues = [];
      each(change.newValues, function (value) {
        newValues.push(_this4._serializer.toJSON(value));
      });
      return {
        type: change.type,
        oldIndex: change.oldIndex,
        newIndex: change.newIndex,
        oldValues: oldValues,
        newValues: newValues
      };
    }
  }]);
  return ObservableUndoableList;
}(ObservableList);
/**
 * Namespace for ObservableUndoableList utilities.
 */
(function (ObservableUndoableList) {
  /**
   * A default, identity serializer.
   */var IdentitySerializer = /*#__PURE__*/function () {
    function IdentitySerializer() {
      _classCallCheck(this, IdentitySerializer);
    }
    _createClass(IdentitySerializer, [{
      key: "toJSON",
      value:
      /**
       * Identity serialize.
       */
      function toJSON(value) {
        return value;
      }
      /**
       * Identity deserialize.
       */
    }, {
      key: "fromJSON",
      value: function fromJSON(value) {
        return value;
      }
    }]);
    return IdentitySerializer;
  }();
  ObservableUndoableList.IdentitySerializer = IdentitySerializer;
})(ObservableUndoableList || (ObservableUndoableList = {}));